import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';

import { ROLES } from '@data-access';

/** Where the organization column is shown (DISTRI only sees it on dashboard and users). */
export type OrganizationColumnContext = 'dashboard' | 'users' | 'list';

const ORGANIZATION_COLUMN_KEYS = new Set([
  'organizations',
  'organization',
  'organization.name',
]);

export function canViewOrganizationColumn(
  role: ROLES | undefined,
  context: OrganizationColumnContext = 'list',
): boolean {
  if (role !== ROLES.DISTRI) {
    return true;
  }

  return context === 'dashboard' || context === 'users';
}

export function filterOrganizationColumns<T extends MRT_RowData>(
  columns: MRT_ColumnDef<T>[],
  visible: boolean,
): MRT_ColumnDef<T>[] {
  if (visible) {
    return columns;
  }

  return columns.filter((column) => {
    const key =
      column.id ?? (column.accessorKey as string | undefined);
    return !key || !ORGANIZATION_COLUMN_KEYS.has(key);
  });
}
